import { Controller } from "@hotwired/stimulus"
import { get, FetchRequest } from '@rails/request.js'
import Swal from 'sweetalert2'
import { I18n } from 'i18n-js';
import locales from '../locales.json';
import { file_preview_status_path, file_preview_path } from "../routes"

// Connects to data-controller="file-group"
export default class extends Controller {
  static values = {
    createUrl: String,
    editTitleUrl: String,
    moveUrl: String,
    deleteUrl: String,
    fileId: String
  }

  connect() {
    this.i18n = new I18n(locales);
    this.i18n.locale = document.querySelector("meta[name='locale']").content
  }

  async updatePreview() {
    try {
      const response = await fetch(file_preview_path(this.fileIdValue))
      if (response.ok) {
        const html = await response.text()
        this.element.innerHTML = html
      }
    } catch (error) {
      console.error("Error updating preview:", error)
    }
  }

  async file_edit_dialog(event) {
    event.preventDefault();

    const result = await Swal.fire({
      title: 'Cím szerkesztése',
      input: 'text',
      inputPlaceholder: 'Cím',
      showCancelButton: true,
      showDenyButton: true,
      denyButtonText: 'Cím törlése',
      confirmButtonText: 'Mentés',
      cancelButtonText: 'Mégse',
      inputValidator: (value) => {
        if (!value && !Swal.getDenyButton().classList.contains('swal2-deny')) {
          return 'A mező kitöltése kötelező!'
        }
      },
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-secondary',
        denyButton: 'btn btn-danger',
        input: 'form-control w-auto',
        popup: 'border-0 shadow rounded',
        title: 'h5',
      },
      buttonsStyling: false
    })

    if (result.isConfirmed) {
      const request = new FetchRequest(
        "post",
        this.editTitleUrlValue,
        {
          body: JSON.stringify({title: result.value, group_id: event.params.groupId}),
          responseKind: "turbo-stream"
        }
      )
      await request.perform()
    } else if (result.isDenied) {
      // Törlés: üres stringet küldünk, a backend ezt törlésként értelmezi
      const request = new FetchRequest(
        "post",
        this.editTitleUrlValue,
        {
          body: JSON.stringify({title: "", group_id: event.params.groupId}),
          responseKind: "turbo-stream"
        }
      )
      await request.perform()
    }
  }

  async create_dialog(event) {
    event.preventDefault();

    const { value: group_name } = await Swal.fire({
      title: 'Csoport hozzáadása',
      input: 'text',
      inputLabel: 'Csoport neve',
      inputPlaceholder: 'Csoport neve',
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return 'A mező kitöltése kötelező!'
        }
      },
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-secondary',
        input: 'form-control w-auto',
        popup: 'border-0 shadow rounded',
        title: 'h5',
      },
      buttonsStyling: false
    })

    if (group_name) {
      const request = new FetchRequest(
        "post",
        this.createUrlValue,
        {
          body: JSON.stringify({name: group_name}),
          responseKind: "turbo-stream"
        }
      )
      const response = await request.perform()
    }
  }

  async file_move_dialog(event) {
    event.preventDefault();

    const { value: group_id } = await Swal.fire({
      title: 'Csoport kiválasztása',
      input: 'select',
      inputOptions: event.params.groups,
      inputLabel: 'Csoport neve',
      inputPlaceholder: 'Csoport neve',
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return 'A mező kitöltése kötelező!'
        }
      },
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-secondary',
        input: 'form-control w-auto',
        popup: 'border-0 shadow rounded',
        title: 'h5',
      },
      buttonsStyling: false
    })

    if (group_id) {
      const request = new FetchRequest(
        "post",
        this.moveUrlValue,
        {
          body: JSON.stringify({file_id: event.params.fileId, group_id: group_id, original_group_id: event.params.originalGroupId}),
          responseKind: "turbo-stream"
        }
      )
      const response = await request.perform()
    }
  }

  async delete(event) {
    event.preventDefault();

    if (confirm(this.i18n.t('helpers.confirm'))) {
      const request = new FetchRequest(
        "delete",
        this.deleteUrlValue,
        {
          body: JSON.stringify({group_id: event.params.groupId}),
          responseKind: "turbo-stream"
        }
      )
      const response = await request.perform()
    }
  }
}
